<template>
  <div>
    <RecoverAccount
      :title="$t('unlockTitle')"
      :notice="$t('unlockNotice')"
      :confirmHint="$t('hint.unlock.confirmSend')"
      :requestPath="'unlock'"
    />
  </div>
</template>

<script>
import RecoverAccount from '@/controls/RecoverAccount'

export default {
  components: {
    RecoverAccount,
  },
}
</script>

  <style lang="scss" scoped>

  </style>
